import React, { Component } from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

//Reducer
import { apiCallRequest } from '../../../reducers/api';
import { getMasterRoutes } from '../../../reducers/map/api';

//Component
import { HERE_MIGRATION_STATUS_OPTIONS } from '../hereMigrationFilter';

//Config
import Configs from "../../../config/config";
const env = process.env.NODE_ENV;

const styles = {
    select: {
        fontSize: '0.8em',
    },
};

// A visible, always-on dropdown in the MIGRATION column -- as opposed to
// ag-grid's cellEditor approach, which only shows a select once the cell is
// clicked into edit mode. Changing it writes hereMigrationStatus directly
// onto this row (no copy/delete of any other row, unlike Promote).
class HereMigrationStatusRenderer extends Component {
    handleChange = event => {
        const status = event.target.value;
        if (status === this.props.data.hereMigrationStatus) return;

        this.props.API_REQUEST({
            url: Configs[env].BACKEND_HOST + "/route/" + this.props.data.id + "/hereMigrationStatus",
            form: { status },
            method: "PUT",
            callback: this.reload
        });
    }
    reload = () => {
        this.props.GET_MASTER_ROUTE({
            url: Configs[env].BACKEND_HOST + "/routeCond",
            filter: {
                logisticsRouteId: this.props.logisticRouteForm.logisticsRouteId,
            }
        });
    }
    render() {
        const { classes, data } = this.props;

        // Rows the migration script never touched have no status to show
        // or change.
        if (data.hereMigrationStatus == null) return null;

        return (
            <Select
                value={data.hereMigrationStatus}
                onChange={this.handleChange}
                className={classes.select}
                disableUnderline
                fullWidth
            >
                {HERE_MIGRATION_STATUS_OPTIONS.map(option =>
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                )}
            </Select>
        );
    }
}

const mapStateToProps = function(state, ownProps) {
    return {
        ...ownProps,
        logisticRouteForm: state.mapForm.logisticRouteForm,
    }
};

const mapActionsToProps = {
    API_REQUEST: apiCallRequest,
    GET_MASTER_ROUTE: getMasterRoutes,
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapActionsToProps
    ),
    withStyles(styles)
);

export default enhance(HereMigrationStatusRenderer)
